import { ScenarioBase, ScenarioType } from "@mutiny-group/sbo-openapi-client";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

export const createScenarioV2 = (
  scenarioBuilderClient: ScenarioBuilderClient,
  scenarioType: ScenarioType
): Promise<ScenarioBase> => {
  return scenarioBuilderClient.scenarios.createScenario({
    createScenarioRequest: {
      scenarioType,
    },
  });
};
